import { render, staticRenderFns } from "./column-header-content.vue?vue&type=template&id=0f81e2d3&"
import script from "./column-header-content.vue?vue&type=script&lang=js&"
export * from "./column-header-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports